/* Copyright (c) 2020 Paul Nebel */

/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

import ErrorBoundary from './error-boundary';
import Header from './header';
import './layout.css';

const Layout = ({ children }) => (
    <StaticQuery
        query={ graphql`
            query SiteTitleQuery {
                site {
                    siteMetadata {
                        title
                    }
                }
            }
        `}
        render={ data => (
            <>
                <Helmet>
                    <link
                        rel='stylesheet'
                        href='https://cdnjs.cloudflare.com/ajax/libs/bulma/0.9.2/css/bulma.min.css'
                        integrity='sha512-byErQdWdTqREz6DLAA9pCnLbdoGGhXfU6gm1c8bkf7F51JVmUBlayGe2A31VpXWQP+eiJ3ilTAZHCR3vmMyybA=='
                        crossOrigin='anonymous'
                    />
                    <link
                        rel='stylesheet'
                        href='https://unpkg.com/bulmaswatch/superhero/bulmaswatch.min.css'>
                    </link>
                    <script src='https://kit.fontawesome.com/38118934fb.js' crossOrigin='anonymous'></script>
                </Helmet>
                <Header
                    siteTitle={ data.site.siteMetadata.title }
                />
                <div
                    style={{
                        margin: `0 auto`,
                        maxWidth: 540,
                        padding: `0rem 1rem`,
                    }}
                >
                    <ErrorBoundary>
                        <main>
                            {children}
                        </main>
                    </ErrorBoundary>
                </div>
            </>
        )}
    />
);

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
